export default function initM12() {
    const $ = jQuery
    jQuery('#verticalTaba').easyResponsiveTabs({
        type: 'vertical',
        width: 'auto',
        fit: true
    });
}